var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreateClientHotlineReorder } from '@/actions/ClientHotlineActions';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import Layout from '@/container/Layout';
import { usePrevPathContext } from '@/context/PrevPathContext';
import { useHotlineClientCreateFormContext } from '@/feature/hotline/client/create/context/HotlineClientCreateFormContext';
import { useHotlineClientReorderFetch } from '@/feature/hotline/client/create/hook/useHotlineClientReorderFetch';
import { HotlineClientCreateInputView } from '@/feature/hotline/client/create/input/page/HotlineClientCreateInputView';
import { HotlineClientCreateInputViewSkeleton } from '@/feature/hotline/client/create/input/page/HotlineClientCreateInputViewSkeleton';
import { getHotlineClientCreateSubmitValues } from '@/feature/hotline/client/create/util/getHotlineClientCreateSubmitValues';
import { getHotlineClientReorderDefaultValues } from '@/feature/hotline/client/create/util/getHotlineClientReorderDefaultValues';
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useParams } from '@/hooks/lib/react-router/useParams';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名ホットライン投稿編集（ロジック部分のみ）
 */
export const HotlineClientEditInputPage = () => {
    const { id = '' } = useParams();
    // 「戻るボタン」のリンク取得
    const prevPath = usePrevPathContext();
    // フォームの値を取得
    const { formValues, setFormValues } = useHotlineClientCreateFormContext();
    const history = useNavigate();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { fetchReorderData, isLoading, reorder } = useHotlineClientReorderFetch({
        dispatch,
        id,
        initialDoingState: !formValues,
        unmountRef,
    });
    const defaultValues = useMemo(() => formValues !== null && formValues !== void 0 ? formValues : getHotlineClientReorderDefaultValues(reorder), [formValues, reorder]);
    /**
     * 送信処理
     */
    const onSubmit = useCallback((formValue) => __awaiter(void 0, void 0, void 0, function* () {
        // バリデーションだけ実行
        yield wrapDispatch(dispatch, apiCreateClientHotlineReorder({
            json: getHotlineClientCreateSubmitValues(formValue),
            path: { id },
        }, {
            isValidateOnly: true,
        }));
        setFormValues(formValue);
        // 送信後は確認画面へ遷移
        if (!unmountRef.current) {
            history.push(pagePath.hotline.client.editConfirm(id));
        }
    }), [dispatch, history, setFormValues, id, unmountRef]);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            // 確認画面から戻ってきた場合を考慮して、既にフォームのstateがある場合は再取得しない
            if (!formValues) {
                yield fetchReorderData();
            }
        }))();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // データが取得できなかった場合は一覧に戻す
    if (!isLoading && !defaultValues) {
        return _jsx(CustomRedirect, { to: pagePath.mypage.client.hotline() });
    }
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { relativePath: pagePath.hotline.client.editInput(id), title: '匿名コンサルホットライン 再募集 - 入力 | PROFFIT' }), _jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: isLoading ? (_jsx(HotlineClientCreateInputViewSkeleton, {})) : (_jsx(HotlineClientCreateInputView, { defaultValues: defaultValues, onSubmit: onSubmit, prevLinkPath: prevPath || pagePath.hotline.client.detailNegotiate(id) })) }))] }));
};
